/**
 * @generated SignedSource<<50f60fa3c9e9c7caff13e59645635684>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptInvitationInput = {
  clientMutationId?: string | null;
  token: string;
};
export type useAuthContext_AcceptInvitationMutation$variables = {
  input: AcceptInvitationInput;
};
export type useAuthContext_AcceptInvitationMutation$data = {
  readonly Auth: {
    readonly acceptInvitation: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type useAuthContext_AcceptInvitationMutation = {
  response: useAuthContext_AcceptInvitationMutation$data;
  variables: useAuthContext_AcceptInvitationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "AcceptInvitationPayload",
        "kind": "LinkedField",
        "name": "acceptInvitation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_AcceptInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_AcceptInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8106d7560f418930c7640d42d4cd4291",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_AcceptInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_AcceptInvitationMutation(\n  $input: AcceptInvitationInput!\n) {\n  Auth {\n    acceptInvitation(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ec4a30ad4ebc39d01cdc46c5d2f55e1";

export default node;
